module.exports = __webpack_public_path__ + "static/img/9.652841d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/9.jpg
// module id = 32EP
// module chunks = 1